import {isValidURL, validateEmail} from '../validation'
import {getValidName} from '../../services/utils/index'

export async function AuditValidateForm(step, form_state) {
  let err = []
  let today = new Date()
  today.setDate(today.getDate() - 1)

  if (step === 0) {
    if (form_state.auditDetails.name === '' && form_state.paneState.modalFor === 'Audit') {
      err.push({error_field: 'name', error_message: 'Audit Name is required.'})
    } else if (
      form_state.auditDetails.template_name === '' &&
      form_state.paneState.modalFor === 'Template'
    ) {
      err.push({error_field: 'template_name', error_message: 'Template Name is required.'})
    }
    if (form_state.auditDetails.method === undefined) {
      err.push({error_field: 'method', error_message: 'Audit Method is required.'})
    }
    if (form_state.auditDetails.start_date === '' || form_state.auditDetails.start_date === null) {
      err.push({error_field: 'start_date', error_message: 'Start date is required.'})
    } else if (
      new Date(form_state.auditDetails.start_date) < today &&
      !form_state.auditDetails.in_buffer_time &&
      form_state.recurring.showRecurrence
    ) {
      err.push({error_field: 'start_date', error_message: 'Start date must be today or later.'})
    } else if (
      new Date(form_state.auditDetails.start_date) < today &&
      form_state.paneState.modalType !== 'edit'
    ) {
      err.push({error_field: 'start_date', error_message: 'Start date must be today or later.'})
    }
    if (
      form_state.auditDetails.due_date !== null &&
      new Date(form_state.auditDetails.due_date) < new Date(form_state.auditDetails.start_date)
    ) {
      err.push({error_field: 'due_date', error_message: 'Due date must be later than start date.'})
    }
    if (form_state.auditDetails.due_soon_days < 0 || form_state.auditDetails.due_soon_days > 365) {
      err.push({
        error_field: 'due_soon_days',
        error_message: 'Due Soon Notification must be between 0 and 365 days.',
      })
    }
    if (
      form_state.recurring.showRecurrence &&
      form_state.recurring.recurrence_attributes.audit_appear_days < 0
    ) {
      err.push({
        error_field: 'audit_appear_days',
        error_message: 'Audit Will Appear must be greater than 0.',
      })
    }
    if (
      form_state.recurring.showRecurrence &&
      form_state.recurring.recurrence_attributes.frequency < 1
    ) {
      err.push({
        error_field: 'repeat_duration',
        error_message: 'Repeat period must be greater than 0.',
      })
    }
    if (
      form_state.recurring.showRecurrence &&
      form_state.recurring.recurrence_attributes.willStop === 'After' &&
      form_state.recurring.recurrence_attributes.occurrences < 1
    ) {
      err.push({
        error_field: 'will_stop_times',
        error_message: 'Repeat count must be greater than 0.',
      })
    }
    if (
      form_state.paneState.modalType !== 'edit' &&
      form_state.barState.uniqueNameCheck &&
      form_state.auditDetails.name !== ''
    ) {
      await getValidName(form_state.auditDetails.name, form_state.paneState.modalFor, '').then(
        response => {
          if (response) {
            if (form_state.paneState.modalFor === 'Audit') {
              err.push({error_field: 'name', error_message: 'Please enter a unique audit name.'})
            } else {
              err.push({error_field: 'name', error_message: 'Please enter a unique template name.'})
            }
          }
        }
      )
    }
    if (
      form_state.paneState.modalType === 'edit' &&
      form_state.barState.uniqueNameCheck &&
      form_state.auditDetails.name !== ''
    ) {
      await getValidName(
        form_state.auditDetails.name,
        form_state.paneState.modalFor,
        form_state.auditDetails.id
      ).then(response => {
        if (response) {
          if (form_state.paneState.modalFor === 'Audit') {
            err.push({error_field: 'name', error_message: 'Please enter a unique audit name.'})
          } else {
            err.push({error_field: 'name', error_message: 'Please enter a unique template name.'})
          }
        }
      })
    }
  } else if (step === 1) {
    if (form_state.groupDetails.audit_entities_attributes[0].entity_name === '') {
      err.push({error_field: 'group', error_message: 'Group is required.'})
    }
    if (
      form_state.groupDetails.audit_entities_attributes[0].audit_entity_field_attributes
        .field_name === ''
    ) {
      err.push({error_field: 'field', error_message: 'Display Field is required.'})
    }
    if (
      form_state.groupDetails.allow_auto_update_fields &&
      form_state.groupDetails.audit_entities_attributes[0]
        .audit_entity_auto_update_fields_attributes.length === 0
    ) {
      err.push({
        error_field: 'auto_updates_attributes',
        error_message: 'At least one auto update field is required.',
      })
    }
    if (
      form_state.groupDetails.allow_user_update_fields &&
      form_state.groupDetails.audit_entities_attributes[0].audit_entity_user_fields_attributes
        .length === 0
    ) {
      err.push({
        error_field: 'audit_fields_attributes',
        error_message: 'At least one user update field is required.',
      })
    }
    AuditValidateAutoUpdateForm(
      form_state.groupDetails.audit_entities_attributes[0]
        .audit_entity_auto_update_fields_attributes
    ).then(auto_err => {
      auto_err.map(err_field => {
        err.push({
          error_field: err_field.error_field,
          error_message: err_field.error_message,
        })
        return true
      })
    })
  } else if (step === 2) {
    if (form_state.assignAudit.audit_users_attributes.length === 0) {
      err.push({error_field: 'name', error_message: 'At least one Assignee is required.'})
    }
  }
  return err
}

export async function AuditValidateAutoUpdateForm(autoUpdateField) {
  let err = []

  autoUpdateField.map(field => {
    if (field.value_name === '' && field.is_required) {
      err.push({
        error_field: 'auto_updates_attributes',
        error_message: `You must provide values for required attributes. `,
      })
      err.push({
        error_field: field.field_id,
        error_message: `You must provide a value for ${field.field_name} `,
      })
    } else if (field.field_type === 'NumericField') {
      if (isNaN(field.value_name)) {
        err.push({
          error_field: 'auto_updates_attributes',
          error_message: `You must provide valid values for attributes.`,
        })
        err.push({error_field: field.field_id, error_message: 'Value must be numeric.'})
      }
    } else if (field.field_type === 'UrlField') {
      if (!isValidURL(field.value_name)) {
        err.push({
          error_field: 'auto_updates_attributes',
          error_message: `You must provide valid values for attributes.`,
        })
        err.push({error_field: field.field_id, error_message: 'Value must be a valid URL.'})
      }
    } else if (field.field_type === 'EmailField') {
      if (!validateEmail(field.value_name)) {
        err.push({
          error_field: 'auto_updates_attributes',
          error_message: `You must provide valid values for attributes.`,
        })
        err.push({
          error_field: field.field_id,
          error_message: 'Value must be a valid E-mail address.',
        })
      }
    }
    return true
  })
  return err
}
